export default "<p>event-edit works!</p>\n"